import moment from 'moment';
import 'moment-timezone';
import React, { Component, useContext } from "react";
import { Button } from 'react-bootstrap';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import AuthContext from '../auth-context';
import FormikDatetime from '../Shared/FormikDateTime';
import Pagination from "../Shared/pagination";
import PhoneNumber from '../Shared/PhoneNumber';
import TrialCoachingSessionsService from '../utils/TrialCoachingSessionsService';
import { examBoardForRegion } from '../utils/variables';
import AssignTCSModal from './AssignTCSModal';
import Flags from './Flags';
import SendBulkSmsModal from './SendBulkSmsModal';

const AssignedTo = ({ deal, showAssignModal, coachName }) => {
  const authStore = useContext(AuthContext)

  if (deal.tcs_assigned_to) {
    if (authStore.hasRole('coach_restricted')) {
      return <span>{coachName(deal.tcs_assigned_to)}</span>
    } else {
      return <span className='btn-link' onClick={() => showAssignModal(deal)}>{coachName(deal.tcs_assigned_to)}</span>
    }
  } else {
    return <Button bsStyle='info' bsSize='xs' onClick={() => showAssignModal(deal)}>Assign</Button>
  }
}

class TCSList extends Component {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    const authStore = this.context

    this.isRestrictedCoach = authStore.hasRole('coach_restricted')
    const assigned = this.isRestrictedCoach ? authStore.profile.email : ""
    const filter = { view: "list", assigned: assigned }
    if (props.view === 'booked') {
      filter.begin = moment().subtract(1, 'day').format("DD MMM YYYY")
      filter.end = moment().add(1, 'week').format("DD MMM YYYY")
      filter.includeCompleted = true
    }
    this.state = {
      filter: filter,
      events: [],
      coaches: props.coaches,
      currentPage: 1,
      totalPages: 1,
      per: 50,
      view: props.view,
      modalAssignDeal: undefined,
      showModalAssignTCS: false,
      showBulkSmsModal: false,
      isAdmin: authStore.hasRole("admin")
    };

    this.onPageChange = this.onPageChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      if (this.props.match.params.view !== prevProps.match.params.view) {
        const assigned = this.isRestrictedCoach ? this.context.profile.email : ""
        const filter = { view: "list", assigned: assigned }
        if (this.props.view === 'booked') {
          filter.begin = moment().subtract(1, 'day').format("DD MMM YYYY")
          filter.end = moment().add(1, 'week').format("DD MMM YYYY")
          filter.includeCompleted = true
        }
        this.setState({ view: this.props.view, filter: filter, currentPage: 1 }, this.fetchEvents)
      }
      if (this.props.coaches !== prevProps.coaches) {
        this.setState({ coaches: this.props.coaches })
      }
    }
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, this.fetchEvents)
  }

  onPageChange(currentPage) {
    this.setState({ currentPage }, () => this.fetchEvents());
  }

  handleFilterChange(event) {
    let filter = { ...this.state.filter };
    filter[event.target.id] = event.target.value;
    this.setState({ filter: filter, currentPage: 1 }, this.fetchEvents);
  }

  dateFilterChanged(field, value) {
    let filter = { ...this.state.filter };
    filter[field] = value.format("DD MMM YYYY");
    this.setState({ filter: filter, currentPage: 1 }, this.fetchEvents);
  }

  fetchEvents() {
    TrialCoachingSessionsService.index({ view: this.state.view, filter: this.state.filter, page: this.state.currentPage, per: this.state.per }).then(data => {
      let events = data.results
      this.setState({ loadingInProgress: false, events: events, totalCount: data.total_count, totalPages: Math.ceil(data.total_count / this.state.per) });
    });
  }

  handleAssignedChange(dealId, event) {
    this.setState({ actionInProgress: true })
    TrialCoachingSessionsService.takeAction('assign', dealId, { email: event.target.value }).then((response) => {
      const events = JSON.parse(JSON.stringify(this.state.events))
      const index = events.findIndex((e) => { return e.id === dealId })
      events[index].tcs_assigned_to = response.tcs_assigned_to
      this.setState({ events: events, actionInProgress: false });
      Alert.success(`Assigned to ${response.tcs_assigned_to || 'nobody'}`)
    })
  }

  dealAssigned = () => {
    this.setState({ showModalAssignTCS: false, modalAssignDeal: undefined }, this.fetchEvents)
  }

  coachName = (email) => {
    if (!this.state.coaches) return email
    const coach = this.state.coaches.find((c) => c.email === email)
    if (!coach) return email
    return coach.region ? `${coach.name} - ${coach.region}` : coach.name
  }

  render() {
    const List = props => {
      return (
        <tbody>
          {props.events.map(deal => (
            <ListItem
              key={deal.id}
              deal={deal}
            />))
          }
        </tbody>
      );
    };

    const ListItem = props => {
      const titleCase = (str) => {
        if (!str) return str
        return str.replace(/_/g, ' ').replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); })
      }

      const { deal } = props
      return (
        <tr key={props.index}>
          <td><Link to={`/m1/deals/${deal.id}`} style={{ whiteSpace: 'nowrap' }}>Deal #{deal.id}</Link></td>
          <td>
            <Link to={`/m1/deals/${deal.id}`}>{(deal.last_name || deal.first_name || 'unknown').toUpperCase()}</Link>
          </td>
          <td><PhoneNumber number={deal.mobile}></PhoneNumber></td>
          <td>
            <Moment format="ddd h:mma MMM Do YYYY">{deal.tcs_at}</Moment>
          </td>
          <td>
            <AssignedTo deal={deal} coachName={this.coachName} showAssignModal={(d) => this.setState({ showModalAssignTCS: true, modalAssignDeal: d }) } />
          </td>
          <td>{deal.region}/{examBoardForRegion(deal.region)}</td>
          <td>{deal.student_year_level}</td>
          <td style={{whiteSpace: 'nowrap'}}>{deal.tcs_parents_attending_tcs && deal.tcs_parents_in_household ? <>{deal.tcs_parents_attending_tcs} of {deal.tcs_parents_in_household}</> : <>-</>}</td>
          {this.state.view === 'on_hold'
            ? <td>
              <p>On Hold by {deal.on_hold_by}<br />Until {moment(deal.on_hold_until).format("DD MMM YYYY h:mm a")}</p>
              {deal.on_hold_reason && <p>
                {deal.on_hold_reason.split('\n').map((item, key) => {
                  return <span key={key}>{item}<br /></span>
                })}
              </p>}

            </td>
            : <>
              <td>
                {titleCase(deal.booking_from)}
              </td>
              <td>
                {titleCase(deal.business_stream)}
              </td>
            </>}
          <td>
            <Flags deal={deal} />
          </td>

        </tr>
      );
    };
    return (
      <div>
        <div className="row" style={{ marginBottom: "10px" }}>
          <div>
            {!this.isRestrictedCoach && (
              <div className="col-sm-2">
                <select
                  id="assigned"
                  value={this.state.filter.assigned}
                  onChange={this.handleFilterChange}
                >
                  <option value="">(assigned to anyone)</option>
                  <option value="unassigned">(NOT assigned)</option>
                  {this.state.coaches.map(coach => (
                    <option key={coach.email} value={coach.email}>
                      {coach.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {this.state.isAdmin && (
              <Button
                bsStyle="info"
                bsSize="small"
                onClick={() => this.setState({ showBulkSmsModal: true })}
              >
                Send Bulk Sms
              </Button>
            )}
          </div>

          {!this.isRestrictedCoach && this.state.view === "booked" && (
            <div className="col-sm-3">
              <FormikDatetime
                field="begin"
                input={{
                  value: this.state.filter.begin,
                  onChange: this.dateFilterChanged,
                  onBlur: () => {}
                }}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>
          )}

          {!this.isRestrictedCoach && this.state.view === "booked" && (
            <div className="col-sm-3">
              <FormikDatetime
                field="end"
                input={{
                  value: this.state.filter.end,
                  onChange: this.dateFilterChanged,
                  onBlur: () => {}
                }}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>
          )}

          <div className="col-sm-3">
            {this.state.totalPages > 1 && (
              <div className="pull-right">
                <Pagination
                  currentPage={this.state.currentPage}
                  totalPages={this.state.totalPages}
                  onChange={this.onPageChange}
                />
              </div>
            )}
          </div>
        </div>

        {this.state.events.length === 0 ? (
          <div>No matches</div>
        ) : (
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table className="table table-hover table-bordered" style={{ minWidth: '1000px' }}>
              <thead className="dark">
                <tr>
                  <th style={{ width: 10 }}>ID</th>
                  <th colSpan="2">Parent</th>
                  <th>Trial Coaching Session</th>
                  <th>Assigned To</th>
                  <th>Region</th>
                  <th>Year</th>
                  <th>Parents</th>
                  {this.state.view === "on_hold" ? (
                    <th>Hold Details</th>
                  ) : (
                    <>
                      <th>From</th>
                      <th>Stream</th>
                    </>
                  )}
                  <th>Flags</th>
                </tr>
              </thead>
              <List events={this.state.events} />
            </table>
          </div>
        )}
        <AssignTCSModal
          showModal={this.state.showModalAssignTCS}
          deal={this.state.modalAssignDeal}
          onConfirmModal={() =>
            this.setState(
              { showModalAssignTCS: false, modalAssignDeal: undefined },
              this.dealAssigned
            )
          }
          onCloseModal={() =>
            this.setState({
              showModalAssignTCS: false,
              modalAssignDeal: undefined
            })
          }
        />
        <SendBulkSmsModal
          showModal={this.state.showBulkSmsModal}
          onConfirmModal={() => this.setState({ showBulkSmsModal: false })}
          onCloseModal={() =>
            this.setState({
              showBulkSmsModal: false
            })
          }
        />
      </div>
    );
  }
}

export default TCSList
